import { FULL_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
export function getInitiativeRoute(initiativeId) {
    var _a;
    return FULL_ROUTES.INITIATIVES_DETAIL.replace(PARAMS.ID, (_a = initiativeId === null || initiativeId === void 0 ? void 0 : initiativeId.toString()) !== null && _a !== void 0 ? _a : '');
}
export function getMonitorRoute(applicationId) {
    var _a;
    return FULL_ROUTES.MONITORS.replace(PARAMS.ID, (_a = applicationId === null || applicationId === void 0 ? void 0 : applicationId.toString()) !== null && _a !== void 0 ? _a : '');
}
